export const CONTINGENT_ACCOUNT_NAME = 'CONTINGENT';